import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi Umum Sekolah")
], -1)
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = { class: "col-lg-6 fv-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nama Sekolah", -1)
const _hoisted_9 = { class: "col-lg-6 fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Initial", -1)
const _hoisted_11 = { class: "row mb-6" }
const _hoisted_12 = { class: "col-lg-6 fv-row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Email", -1)
const _hoisted_14 = { class: "col-lg-6 fv-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor Telepon", -1)
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = { class: "col-lg-6 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Tipe Sekolah", -1)
const _hoisted_19 = {
  key: 0,
  class: "col-lg-6 fv-row"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Custom Aplikasi", -1)
const _hoisted_21 = {
  key: 1,
  class: "col-lg-6 fv-row"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Custom Aplikasi", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Alamat Sekolah")
], -1)
const _hoisted_24 = { class: "row mb-6" }
const _hoisted_25 = { class: "col-lg-6 fv-row" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Provinsi", -1)
const _hoisted_27 = { class: "col-lg-6 fv-row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Kota/ Kabupaten", -1)
const _hoisted_29 = { class: "row mb-6" }
const _hoisted_30 = { class: "col-lg-6 fv-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Kecamatan", -1)
const _hoisted_32 = { class: "col-lg-6 fv-row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Alamat", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi Khusus")
], -1)
const _hoisted_35 = { class: "row mb-6" }
const _hoisted_36 = { class: "col-lg-6 fv-row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Bank", -1)
const _hoisted_38 = { class: "col-lg-6 fv-row" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Funding", -1)
const _hoisted_40 = { class: "row mb-6" }
const _hoisted_41 = { class: "col-lg-6 fv-row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor NPWP", -1)
const _hoisted_43 = { class: "col-lg-6 fv-row" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Tampilan NPWP", -1)
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "row mb-6" }
const _hoisted_47 = { class: "col-lg-6 fv-row" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Status", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi PIC dan Sales")
], -1)
const _hoisted_50 = { class: "row mb-6" }
const _hoisted_51 = { class: "col-lg-6 fv-row" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nama PIC ", -1)
const _hoisted_53 = { class: "col-lg-6 fv-row" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Email PIC", -1)
const _hoisted_55 = { class: "row mb-6" }
const _hoisted_56 = { class: "col-lg-6 fv-row" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Nomor Telepon PIC", -1)
const _hoisted_58 = { class: "col-lg-6 fv-row" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Sales Area", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informasi Tambahan")
], -1)
const _hoisted_61 = { class: "row mb-6" }
const _hoisted_62 = { class: "col-lg-6 fv-row" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Tanggal Dibuat", -1)
const _hoisted_64 = { class: "col-lg-6 fv-row" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Dibuat Oleh", -1)
const _hoisted_66 = { class: "row mb-6" }
const _hoisted_67 = { class: "col-lg-6 fv-row" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Catatan", -1)
const _hoisted_69 = { class: "col-lg-6 fv-row" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Target Live", -1)
const _hoisted_71 = { class: "row mb-6" }
const _hoisted_72 = { class: "col-lg-6 fv-row" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Referensi Dari", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Field, {
                type: "text",
                name: "name",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.detail.name) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_Field, {
                type: "text",
                name: "initial",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.initial,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.detail.initial) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_Field, {
                type: "text",
                name: "email",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail.email) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_Field, {
                type: "text",
                name: "phone",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.phone,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.detail.phone) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_Field, {
                type: "text",
                name: "schoolType",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.schoolType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.detail.schoolType) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            (_ctx.detail.customApp === 'true')
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "customApp",
                    class: "form-control form-control-lg",
                    placeholder: "YA",
                    disabled: ""
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.detail.customApp === 'false')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "customApp",
                    class: "form-control form-control-lg",
                    placeholder: "Tidak",
                    disabled: ""
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_Field, {
                type: "text",
                class: "form-control form-control-lg",
                name: "province",
                autocomplete: "off",
                modelValue: _ctx.detail.address.province,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.detail.address.province) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(_component_Field, {
                type: "text",
                class: "form-control form-control-lg",
                name: "city",
                autocomplete: "off",
                modelValue: _ctx.detail.address.city,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.detail.address.city) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode(_component_Field, {
                type: "text",
                class: "form-control form-control-lg",
                name: "regency",
                autocomplete: "off",
                modelValue: _ctx.detail.address.regency,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.detail.address.regency) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createVNode(_component_Field, {
                type: "text",
                name: "detail",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.address.detail,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.detail.address.detail) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createVNode(_component_Field, {
                type: "text",
                name: "bankData",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.bankData,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.detail.bankData) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createVNode(_component_Field, {
                type: "text",
                name: "fundingName",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.fundingName,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.detail.fundingName) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createVNode(_component_Field, {
                type: "number",
                name: "number",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.npwp.number,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.detail.npwp.number) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("img", {
                alt: "",
                class: "img-fluid",
                src: 
                _ctx.url
              
              }, null, 8, _hoisted_45)
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _createVNode(_component_Field, {
                type: "text",
                name: "status",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.status,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.detail.status) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _createVNode(_component_Field, {
                type: "text",
                name: "picName",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.picName,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.detail.picName) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _hoisted_54,
              _createVNode(_component_Field, {
                type: "text",
                name: "picEmail",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.picEmail,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.detail.picEmail) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _createVNode(_component_Field, {
                type: "number",
                name: "picPhone",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.picPhone,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.detail.picPhone) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _createVNode(_component_Field, {
                type: "text",
                name: "salesArea",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.salesArea,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.detail.salesArea) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_60,
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _hoisted_63,
              _createVNode(_component_Field, {
                type: "createTime",
                name: "createTime",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.createTime,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.detail.createTime) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_64, [
              _hoisted_65,
              _createVNode(_component_Field, {
                type: "text",
                name: "creatorName",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.creatorName,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.detail.creatorName) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _hoisted_68,
              _createVNode(_component_Field, {
                type: "text",
                name: "note",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.note,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.detail.note) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_69, [
              _hoisted_70,
              _createVNode(_component_Field, {
                type: "date",
                name: "targetLive",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.targetLive,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.detail.targetLive) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _hoisted_73,
              _createVNode(_component_Field, {
                type: "text",
                name: "referenceFrom",
                class: "form-control form-control-lg",
                modelValue: _ctx.detail.referenceFrom,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.detail.referenceFrom) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}